import { InjectionToken } from '@angular/core';

export const PACKING_BOX_SPECIFY_STATION = new InjectionToken<boolean>(
  'Specification of the name for the station',
  {
    providedIn: 'root',
    factory: () => false,
  }
);

export interface PBTableOption {
  label: string;
  action: (row: any) => void;
  icon?: string;
}
export const PACKING_BOX_EXTRA_OPTIONS = new InjectionToken<PBTableOption[]>(
  'Custom options for the table'
);
